import { CustomColumnHeader, Global } from 'types';

export interface CustomColumnHeadersForLotParams {
  customHeaders: CustomColumnHeader[] | [];
  global: Global;
  incomingColumnTypes?: string[];
  isSupplier?: boolean;
}

export const getCustomColumnHeadersForLot = ({
  global,
  customHeaders,
  incomingColumnTypes,
  isSupplier = false,
}: CustomColumnHeadersForLotParams) => {
  const defaultColumnTypes = Object.values(global.lots.custom_column_headers.column_types);
  const columnTypes = incomingColumnTypes || defaultColumnTypes;

  return customHeaders
    .filter(header => (
      columnTypes.includes(header.column_type) && (!isSupplier || header.is_supplier_visible)))
    .sort((cc1, cc2) => cc1.column_order_index - cc2.column_order_index);
};
